import { OnlineIndicator } from '../OnlineIndicator/OnlineIndicator';

/**
 * Sticky header с заголовком экрана. Manrope Variable display, текст 28px (text-h2).
 * Без кнопки «Назад» — навигация назад через {@link BottomBar} (P-036).
 *
 * v0.4 (ADR-0023): bg-header (peach #FF8C1A) + height 64px (h-16, −20% vs прежние 88px).
 *
 * Главный (Экран 2.0) использует свою шапку с логотипом — {@link HomeHeader}.
 *
 * Block 12 PR-A Phase A5: OnlineIndicator absolute-positioned в правом углу —
 * минимальный layout disruption, title остаётся perfectly centered (justify-center сохранён).
 */
export interface HeaderProps {
  title: string;
}

export function Header({ title }: HeaderProps) {
  return (
    <header className="sticky top-0 z-20 h-16 flex items-center justify-center bg-header border-b border-header-border pl-4 pr-16">
      <h1 className="font-display text-h2 text-ink m-0 truncate">{title}</h1>
      <div className="absolute right-3 top-1/2 -translate-y-1/2">
        <OnlineIndicator />
      </div>
    </header>
  );
}
